import { motion } from "framer-motion";

export default function ProjectCard({ project }) {
  return (

    <motion.div
      whileHover={{ y: -8 }}
      className="bg-zinc-900 border border-zinc-800 hover:border-zinc-600 transition duration-300 rounded-3xl p-6 shadow-lg"
    >

      <h3 className="text-2xl font-semibold mb-3">
        {project.title}
      </h3>

      <p className="text-zinc-300 leading-relaxed">
        {project.desc}
      </p>

      <div className="flex gap-3 mt-6">

        <a
          href={project.github}
          target="_blank"
          rel="noreferrer"
          className="bg-white text-black px-4 py-2 rounded-xl text-sm font-semibold hover:scale-105 transition"
        >
          GitHub
        </a>

        <a
          href={project.live}
          target="_blank"
          rel="noreferrer"
          className="border border-zinc-700 px-4 py-2 rounded-xl text-sm hover:bg-zinc-800 transition"
        >
          Live Demo
        </a>

      </div>

    </motion.div>

  );
}